export const ACCESS_TYPES = {
  LICENSED: "LICENSED",
  ADMIN: "ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
};

export const normalizeAccessType = (value) =>
  String(value || "")
    .trim()
    .toUpperCase();

export const isLicensed = (role) => normalizeAccessType(role) === ACCESS_TYPES.LICENSED;

export const isAdmin = (role) => normalizeAccessType(role) === ACCESS_TYPES.ADMIN;

export const isSuperAdmin = (role) =>
  normalizeAccessType(role) === ACCESS_TYPES.SUPER_ADMIN;

export const canAccessAdminArea = (role) => {
  const normalizedRole = normalizeAccessType(role);
  return (
    normalizedRole === ACCESS_TYPES.ADMIN ||
    normalizedRole === ACCESS_TYPES.SUPER_ADMIN
  );
};

export const canAccessAllowedRole = (userRole, allowed = []) => {
  const normalizedUserRole = normalizeAccessType(userRole);
  const normalizedAllowed = allowed.map(normalizeAccessType).filter(Boolean);

  if (!normalizedUserRole || normalizedAllowed.length === 0) return false;
  if (normalizedAllowed.includes(normalizedUserRole)) return true;

  return (
    normalizedUserRole === ACCESS_TYPES.SUPER_ADMIN &&
    normalizedAllowed.includes(ACCESS_TYPES.ADMIN)
  );
};

export const getHomeRouteForRole = (role) =>
  canAccessAdminArea(role) ? "/admin/dashboard" : "/dashboard";

export const getCreatableAccessTypes = (role) => {
  if (isSuperAdmin(role)) {
    return [
      { label: "Usuario licenciado", value: ACCESS_TYPES.LICENSED },
      { label: "Administrador", value: ACCESS_TYPES.ADMIN },
      { label: "Super administrador", value: ACCESS_TYPES.SUPER_ADMIN },
    ];
  }

  if (isAdmin(role)) {
    return [{ label: "Usuario licenciado", value: ACCESS_TYPES.LICENSED }];
  }

  return [];
};

export const canManageUserRole = (actorRole, targetRole) => {
  if (isSuperAdmin(actorRole)) {
    return Object.values(ACCESS_TYPES).includes(normalizeAccessType(targetRole));
  }

  if (isAdmin(actorRole)) {
    return isLicensed(targetRole);
  }

  return false;
};

export const getAccessTypeLabel = (role) => {
  switch (normalizeAccessType(role)) {
    case ACCESS_TYPES.SUPER_ADMIN:
      return "Super administrador";
    case ACCESS_TYPES.ADMIN:
      return "Administrador";
    case ACCESS_TYPES.LICENSED:
      return "Licenciado";
    default:
      return "Nao informado";
  }
};
